(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["quiz-recommandation"] && !Shopify.designMode) return;
  try {
    
  /* =========================================================
     Quiz state machine
     ========================================================= */
  class QuizRecommandation extends HTMLElement {
    constructor() {
      super();
      this.state = { 1: null, 2: null, 3: null, 4: null, email: '', firstname: '' };
      // Always a STRING, to match this.allSteps and dataset.step values.
      this.currentStep = '1';
      this.allSteps = ['1', '2', '3', '4', '5'];
    }

    connectedCallback() {
      this.recoConfig = this.parseRecoConfig();
      this.bindCardClicks();
      this.bindFooterNav();
      this.bindFormFields();
      this.render();
    }

    parseRecoConfig() {
      const el = this.querySelector('[data-ref="reco-config"]');
      try { return JSON.parse(el.textContent); } catch (e) { return { products: {} }; }
    }

    bindCardClicks() {
      this.querySelectorAll('[data-q]').forEach(card => {
        card.addEventListener('click', e => {
          e.preventDefault();
          const q = card.dataset.q;
          const value = card.dataset.value;
          this.state[q] = value;
          // mark selected within group
          card.parentElement.querySelectorAll('.quiz-rec__card').forEach(c => c.classList.remove('quiz-rec__card--selected'));
          card.classList.add('quiz-rec__card--selected');
          this.updateNextBtn();
          // Auto-advance after a short delay (UX)
          setTimeout(() => this.next(), 350);
        });
      });
    }

    bindFooterNav() {
      const back = this.querySelector('[data-ref="back-btn"]');
      const next = this.querySelector('[data-ref="next-btn"]');
      const restart = this.querySelector('[data-ref="restart-btn"]');
      back && back.addEventListener('click', () => this.back());
      next && next.addEventListener('click', () => this.next());
      restart && restart.addEventListener('click', () => this.restartQuiz());
    }

    bindFormFields() {
      const form = this.querySelector('.quiz-rec__form');
      if (!form) return;
      const email = form.querySelector('#QuizEmail');
      const firstname = form.querySelector('#QuizFirstName');
      const update = () => {
        this.state.email = email.value.trim();
        this.state.firstname = firstname.value.trim();
        this.updateNextBtn();
      };
      [email, firstname].forEach(el => {
        el && el.addEventListener('input', update);
        el && el.addEventListener('change', update);
      });
      // Block only the submits we did not initiate ourselves (e.g. Enter key in
      // the email field). Our own submit — fired from next() — must go through
      // natively: Shopify's spam protection (hCaptcha) hooks the native submit
      // event to inject the captcha token. A fetch() POST bypasses that hook and
      // the storefront answers "400 Missing CAPTCHA token", so nothing is saved.
      form.addEventListener('submit', e => {
        if (this._quizSubmitAllowed) return; // let Shopify handle it
        e.preventDefault();
        e.stopImmediatePropagation();
        return false;
      }, true /* capture phase, runs before any other listener */);

      // Hidden iframe used as the form target: the native POST happens for real
      // (captcha included) but the visitor's page never navigates away.
      let sink = document.querySelector('iframe[name="quiz-rec-sink"]');
      if (!sink) {
        sink = document.createElement('iframe');
        sink.name = 'quiz-rec-sink';
        sink.setAttribute('aria-hidden', 'true');
        sink.setAttribute('tabindex', '-1');
        sink.style.cssText = 'position:absolute;width:0;height:0;border:0;opacity:0;pointer-events:none;';
        document.body.appendChild(sink);
      }
      this._quizSink = sink;
      sink.addEventListener('load', () => { this._quizSubmitDone = true; });
      form.setAttribute('target', 'quiz-rec-sink');
    }

    /* Fill the contact[*] fields then submit the form natively into the hidden
       iframe, so Shopify's captcha hook runs and the customer is created. */
    submitContactInBackground() {
      const form = this.querySelector('.quiz-rec__form');
      if (!form) return;
      const noteField = form.querySelector('[data-ref="quiz-note"]');
      const tagsField = form.querySelector('[name="contact[tags]"]');
      const reco = this.computeReco();
      const payload = {
        quiz: 'trouver-son-masque',
        q1_focus: this.state[1],
        q2_probleme: this.state[2],
        q3_frequence: this.state[3],
        q4_duree: this.state[4],
        firstname: this.state.firstname,
        reco_main: reco.main && reco.main.handle,
        reco_alts: (reco.alts || []).map(a => a.handle),
        ts: new Date().toISOString()
      };
      if (noteField) noteField.value = 'Quiz: ' + JSON.stringify(payload);
      if (tagsField) {
        tagsField.value = [
          'quiz_completed',
          'quiz_focus_' + this.state[1],
          'quiz_pb_' + this.state[2],
          'quiz_freq_' + this.state[3],
          'quiz_intent_' + this.state[4]
        ].join(', ');
      }
      // Native submit into the hidden iframe (see bindFormFields). This is the
      // only path that lets Shopify attach its captcha token.
      this._quizSubmitAllowed = true;
      this._quizSubmitDone = false;
      const fire = () => {
        try {
          if (typeof form.requestSubmit === 'function') form.requestSubmit();
          else form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
        } catch (e) { /* ignore */ }
      };
      fire();
      // Shopify's spam-protection script is lazy-loaded: the very first submit
      // only triggers its download and is cancelled. Retry a few times until the
      // POST actually goes through (the hidden iframe firing "load").
      let tries = 0;
      const retry = setInterval(() => {
        tries++;
        if (this._quizSubmitDone || tries > 6) {
          clearInterval(retry);
          this._quizSubmitAllowed = false;
          return;
        }
        fire();
      }, 1200);
    }

    updateNextBtn() {
      const next = this.querySelector('[data-ref="next-btn"]');
      const back = this.querySelector('[data-ref="back-btn"]');
      if (!next) return;
      const step = String(this.currentStep);
      if (step === '1') back.style.visibility = 'hidden';
      else back.style.visibility = '';

      if (step === '5') {
        next.textContent = 'Voir ma recommandation →';
        next.disabled = !this.isValidEmail(this.state.email);
        const footer = this.querySelector('[data-ref="footer-nav"]');
        if (footer) footer.style.display = '';
      } else if (step === 'reco') {
        // Hide footer on reco screen
        const footer = this.querySelector('[data-ref="footer-nav"]');
        if (footer) footer.style.display = 'none';
      } else {
        next.textContent = 'Suivant →';
        next.disabled = this.state[step] == null;
        const footer = this.querySelector('[data-ref="footer-nav"]');
        if (footer) footer.style.display = '';
      }
    }

    isValidEmail(e) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e); }

    next() {
      if (String(this.currentStep) === '5') {
        // Submit happens via fetch in the background — UI switches IMMEDIATELY
        // to the recommendation screen. The browser does not navigate.
        if (!this.isValidEmail(this.state.email)) return;
        this.submitContactInBackground();
        this.currentStep = 'reco';
        this.renderReco();
        this.render();
        return;
      }
      const order = this.allSteps;
      const idx = order.indexOf(String(this.currentStep));
      if (idx < order.length - 1) {
        this.currentStep = order[idx + 1];
        this.render();
      }
    }

    back() {
      const order = this.allSteps;
      const idx = order.indexOf(String(this.currentStep));
      if (idx > 0) {
        this.currentStep = order[idx - 1];
        this.render();
      }
    }

    render() {
      // Show only the relevant Q2 variant (depends on Q1)
      this.querySelectorAll('.quiz-rec__step').forEach(s => {
        const stepId = s.dataset.step;
        const q1Filter = s.dataset.q1;
        let active = stepId === String(this.currentStep);
        if (active && stepId === '2' && q1Filter && q1Filter !== this.state[1]) active = false;
        s.classList.toggle('quiz-rec__step--active', active);
      });
      // Progress bar
      const bar = this.querySelector('[data-ref="progress-bar"]');
      const stepProgress = { '1': 20, '2': 40, '3': 60, '4': 80, '5': 100, 'reco': 100 };
      if (bar) bar.style.width = (stepProgress[String(this.currentStep)] || 0) + '%';
      this.updateNextBtn();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    /* =========================================================
       Scoring → reco principale + 0 à 2 alternatives
       ========================================================= */
    computeReco() {
      const f = this.state[1];   // focus
      const p = this.state[2];   // problème
      const fr = this.state[3];  // fréquence
      const dur = this.state[4]; // durée
      const cfg = this.recoConfig.products;

      let mainKey = null;
      let altKeys = [];

      let altLabels = ['Idéal aussi pour vous', 'Pour aller plus loin'];
      if (f === 'oeil') {
        if (p === 'cernes' || p === 'poches') { mainKey = 'pp';       altKeys = ['verveine']; }
        else if (p === 'fatigue')              { mainKey = 'verveine'; altKeys = ['pp']; }
        else if (p === 'hydratation')          { mainKey = 'rooibos';  altKeys = ['hydrogel']; }
        else if (p === 'anti_age')             { mainKey = 'hydrogel'; altKeys = ['rooibos']; }
        else                                    { mainKey = 'pp';       altKeys = ['verveine', 'rooibos']; }
      } else if (f === 'visage') {
        if (p === 'deshydratation')            { mainKey = 'softcell'; altKeys = ['biocell']; }
        else if (p === 'pollution')            { mainKey = 'biocell';  altKeys = ['softcell']; }
        else if (p === 'eclat')                { mainKey = 'biocell';  altKeys = ['softcell']; }
        else if (p === 'anti_age')             { mainKey = 'softcell'; altKeys = ['biocell']; }
        else                                    { mainKey = 'softcell'; altKeys = ['biocell']; }
      } else { /* les_deux : un soin regard + le complément visage */
        altLabels = ['Le complément visage', 'Pour aller plus loin'];
        if (p === 'fatigue_generale')          { mainKey = 'verveine'; altKeys = ['biocell', 'pp']; }
        else if (p === 'hydratation')          { mainKey = 'rooibos';  altKeys = ['softcell', 'hydrogel']; }
        else if (p === 'anti_age')             { mainKey = 'hydrogel'; altKeys = ['softcell', 'rooibos']; }
        else                                    { mainKey = 'pp';       altKeys = ['softcell', 'biocell']; }
      }

      const main = cfg[mainKey];
      const alts = altKeys.map(k => cfg[k]).filter(Boolean);

      // Suffix: OU vs Abo + palier in the reco label
      const suffix = this.intentSuffix(fr, dur);
      return { main: main && Object.assign({}, main, { suffix }), alts, altLabels };
    }

    intentSuffix(fr, dur) {
      // Translate the answers into a human-readable label
      // (the actual variant selection happens on the product page)
      const isAbo = (dur === 'abo_1m' || dur === 'abo_2m');
      const tier = (dur === 'essai') ? 'mini' :
                   (dur === 'cure_1m') ? 'moyen' :
                   (dur === 'libre_2_3m') ? 'grand' :
                   (dur === 'abo_1m') ? 'mensuel' : 'bi-mensuel';
      return { isAbo, tier, frequence: fr };
    }

    renderReco() {
      let { main, alts, altLabels } = this.computeReco();
      const nameEl = this.querySelector('[data-ref="reco-name"]');
      const tagEl = this.querySelector('[data-ref="reco-tag"]');
      const cardsEl = this.querySelector('[data-ref="reco-cards"]');
      if (!nameEl || !main) return;

      // Skip products that don't exist in the store (Liquid set url to '')
      const productExists = (p) => p && p.url && p.url !== '';
      if (!productExists(main)) {
        // Try to fall back to first valid alternative
        const fallback = alts.find(productExists);
        if (fallback) {
          main = fallback;
          alts = alts.filter(a => a !== fallback);
        }
      }
      // Filter alts to only existing products
      alts = (alts || []).filter(productExists);

      // Reco name + tagline
      nameEl.textContent = main.name || '';
      const greeting = this.state.firstname ? this.state.firstname + ', ' : '';
      tagEl.textContent = greeting + 'voici ce que nous vous conseillons selon vos réponses.';

      // Cards
      cardsEl.innerHTML = '';
      if (productExists(main)) {
        cardsEl.appendChild(this.buildRecoCard(main, 'main', 'Coup de cœur'));
      }
      alts.slice(0, 2).forEach((a, i) => {
        cardsEl.appendChild(this.buildRecoCard(a, 'alt', altLabels[i]));
      });
    }

    buildRecoCard(p, kind, badge) {
      const card = document.createElement('article');
      card.className = 'quiz-rec__reco-card' + (kind === 'main' ? ' quiz-rec__reco-card--main' : '');
      const badgeClass = (kind === 'main') ? 'quiz-rec__reco-badge' : 'quiz-rec__reco-badge quiz-rec__reco-badge--soft';
      // Use the REAL URL from Liquid (resolved via all_products[handle].url).
      // Fallback to /products/<handle> only if the product wasn't found server-side
      // (which means a 404 anyway — we'll skip such cards in renderReco()).
      const url = p.url || ('/products/' + p.handle);
      const imgHtml = p.image
        ? '<img src="' + p.image + '" alt="' + (p.name || '').replace(/"/g, '&quot;') + '" loading="lazy" width="600" height="450">'
        : '';
      card.innerHTML =
        '<div class="' + badgeClass + '">' + badge + '</div>' +
        '<div class="quiz-rec__reco-img">' + imgHtml + '</div>' +
        '<div class="quiz-rec__reco-body">' +
          '<h3 class="quiz-rec__reco-title">' + (p.name || '') + '</h3>' +
          '<p class="quiz-rec__reco-justif">' + (p.justif || '') + '</p>' +
        '</div>' +
        '<a href="' + url + '" class="quiz-rec__reco-cta">Voir le produit</a>';
      return card;
    }

    /* =========================================================
       Restart the quiz from scratch (clears state, returns to step 1)
       ========================================================= */
    restartQuiz() {
      this.state = { 1: null, 2: null, 3: null, 4: null, email: '', firstname: '' };
      this.currentStep = '1';
      // Reset selected cards visual
      this.querySelectorAll('.quiz-rec__card--selected').forEach(c => c.classList.remove('quiz-rec__card--selected'));
      // Clear form fields
      const email = this.querySelector('#QuizEmail');
      const firstname = this.querySelector('#QuizFirstName');
      if (email) email.value = '';
      if (firstname) firstname.value = '';
      // Reset reco screen content
      const recoCards = this.querySelector('[data-ref="reco-cards"]');
      if (recoCards) recoCards.innerHTML = '';
      const recoName = this.querySelector('[data-ref="reco-name"]');
      if (recoName) recoName.textContent = '';
      const recoTag = this.querySelector('[data-ref="reco-tag"]');
      if (recoTag) recoTag.textContent = '';
      this.render();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }

  if (!customElements.get('quiz-recommandation')) {
    customElements.define('quiz-recommandation', QuizRecommandation);
  }

  } catch(e) { console.error(e); }
})();
})();
